var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SYSTEM-ELEMENTS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SYSTEM-ELEMENTS .cls-1 {\n        fill: #3e4346;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_176",
    "data-name": "Pfad 176",
    className: "cls-1",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_177",
    "data-name": "Pfad 177",
    className: "cls-1",
    d: "M22.7,12.5v2.1H25v3H22.7v1H17.1v-1H15.9c-2.5.1-3.9,1.5-4.2,4.3h-3c.3-3.8,1.8-5.2,3.4-6.3A7.431,7.431,0,0,1,16,14.5h1.2V12.4h5.5m1-.9H16.1v2.1h-.2a9.733,9.733,0,0,0-4.5,1.2C9.5,16,7.6,17.9,7.5,22.9l5,.1c.1-4.5,2.6-4.3,3.5-4.4h.1v1h7.6v-1H26v-5H23.7V11.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_118",
    "data-name": "Gruppe 118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_74",
    "data-name": "Rechteck 74",
    className: "cls-1",
    width: 2.9,
    height: 10.2,
    transform: "translate(26.8 10.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_178",
    "data-name": "Pfad 178",
    className: "cls-1",
    d: "M23.6,5.7H20.9V5.2a.9.9,0,1,0-1.8,0v.4H16.4a.684.684,0,0,0-.7.7v.4a.684.684,0,0,0,.7.7H19v2.9h1.8V7.4h2.7a.684.684,0,0,0,.7-.7V6.4A.563.563,0,0,0,23.6,5.7Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_179",
    "data-name": "Pfad 179",
    className: "cls-1",
    d: "M12,27.7a2,2,0,1,1-4,0c0-1.1,2-4,2-4S12,26.6,12,27.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemElements);
export default __webpack_public_path__ + "static/media/system-elements.f43fd9e0ae1b8ee80bf2d7abcf5dd224.svg";
export { ForwardRef as ReactComponent };